<template>
    <v-footer height="auto" color="#F5F5F5" class="pa-0">
        <v-layout justify-center>
            <v-flex md12 lg8 class="mt-4">
                <v-card flat>
                    <v-card-text class="pa-0">
                        <v-layout row wrap fill-height>
                            <v-flex xs12 sm6 md4 order-xs1 order-sm2 order-md1 class="pa-2">
                                <v-card flat>
                                    <v-card-text class="pb-1">
                                        <v-img :src="footerLogoSrc" :contain="true" width="260" max-width="100%"></v-img>
                                    </v-card-text>
                                    <v-card-text class="mt-4 py-1 body-1">
                                        {{ $t('Core.Footer.pulverit-description') }}
                                        <v-img class="mt-5" :src="`${publicPath}img/certifications.png`" :contain="true"></v-img>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <v-flex xs12 sm12 md4 order-xs2 order-sm1 order-md2 class="pa-2">
                                <v-text-field class="py-3" solo label="Search" append-icon="mdi-magnify"
                                              color="#BFBFBF"></v-text-field>
                                <v-card flat>
                                    <v-card-text class="py-3 body-1">
                                        <span style="font-weight: bold">Pulverit S.p.A.</span><br>
                                        <span v-html="$t('Core.Footer.pulverit-address')"></span>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <v-flex xs12 sm6 md4 order-xs3 order-sm3 order-md3 class="pa-2">
                                <v-card color="#FFFFFF" class="pr-1">
                                    <div class="pa-3">
                                        <v-img class="mt-3" :src="pulvercoatLogo" :contain="true" width="260" max-width="100%"></v-img>
                                    </div>
                                    <v-card-text class="py-3 body-1">
                                        {{ $t('Core.Footer.pulvercoat-description') }}
                                        <div class="pa-3">
                                            <v-img :src="`${publicPath}img/european-commission.jpg`" :contain="true" width="260" max-width="100%"></v-img>
                                        </div>
                                        <div class="pa-3">
                                            <span style="font-size: 11px !important; line-height: 11px;">
                                                {{ $t('Core.Footer.pulvercoat-bottom') }}
                                            </span>
                                        </div>
                                    </v-card-text>
                                    <span class="space"></span><span class="space"></span>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-text class="caption">
                        <v-layout row wrap>
                            <v-flex xs12 sm6 text-xs-center text-sm-left>
                                <span>
                                    {{appAcronym}} {{appVersion}} &copy; {{ new Date().getFullYear() }}
                                </span>
                            </v-flex>
                            <v-flex xs12 sm6 md4 text-xs-center text-sm-right>
                                <span>Powered by</span>
                                <a href="https://www.techgap.it" target="_blank"
                                   class="tertiary--text footer-links">TechGap Italia</a>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-footer>
</template>

<script>
    import {appInfo} from '@/json-common/app-info'
    import i18n from '@/i18n'
    import {publicPath} from "../../../vue.config";

    export default {
        data () {
            return {
                publicPath: publicPath
            }
        },
        computed: {
            appVersion() {
                return appInfo.version
            },
            appAcronym() {
                return appInfo.acronym
            },
            footerLogoSrc() {
                return publicPath + 'img/LOGO-PULVERIT-WEB-' + i18n.locale + '.png'
            },
            pulvercoatLogo() {
                return i18n.locale == 'de' ? publicPath + 'img/pulvercold.png' : publicPath + 'img/pulvercoat.png';
            }
        }
    }
</script>

<style scoped>

</style>
